import { SampleOperation } from '@/api/operations/models/sample-operation'

export const ENTITIES_LABORATORY = {
    SAMPLE: 'sample',
    PORTION: 'portion',
    SUBPORTION: 'subportion'
}

export default [
    {
        id: 'operation.entity.portion.archive',
        uicomponent: 'uicomponent.laboratory.portion.archive',
        type: ENTITIES_LABORATORY.PORTION,
        url: 'portions/pendingArchive',
        gridExportWithBarcode: true
    },
    {
        id: 'operation.entity.portion.cut',
        idAlt: 'operation.entity.subportion.cut',
        uicomponent: 'uicomponent.laboratory.portion.cut',
        type: ENTITIES_LABORATORY.SUBPORTION,
        typeAlt: ENTITIES_LABORATORY.PORTION,
        url: 'portions/subportions/pendingCut',
        urlAlt: 'portions/pendingCut',
        actionUrl: 'portions/cut',
        hasLabelGroup: true,
        deviceType: 'portions/subportions'
    },
    {
        id: 'operation.entity.portion.process',
        uicomponent: 'uicomponent.laboratory.portion.process',
        type: ENTITIES_LABORATORY.PORTION,
        url: 'portions/pendingProcess',
        actionUrl: 'portions/process',
        deviceType: 'portions'
    },
    {
        id: 'operation.entity.portion.make',
        uicomponent: 'uicomponent.laboratory.portion.make',
        type: ENTITIES_LABORATORY.PORTION,
        url: 'portions/pendingMake',
        actionUrl: 'portions/make',
        deviceType: 'portions'
    },
    {
        id: 'operation.entity.portion.to-tissue-processor',
        uicomponent: 'uicomponent.laboratory.portion.to-tissue-processor',
        type: ENTITIES_LABORATORY.PORTION,
        url: 'portions/pendingToTissueProcessor',
        actionUrl: 'portions/toTissueProcessor',
        deviceType: 'portions'
    },
    {
        id: 'operation.entity.portion.unarchive-to-cut',
        uicomponent: 'uicomponent.laboratory.portion.unarchive-to-cut',
        type: ENTITIES_LABORATORY.PORTION,
        url: 'portions/pendingUnarchiveToCut',
        gridExportWithBarcode: true
    },
    {
        id: 'operation.entity.portion.unarchive-to-remake',
        uicomponent: 'uicomponent.laboratory.portion.unarchive-to-remake',
        type: ENTITIES_LABORATORY.PORTION,
        url: 'portions/pendingUnarchiveToRemake',
        gridExportWithBarcode: true
    },
    {
        id: 'operation.entity.subportion.archive',
        uicomponent: 'uicomponent.laboratory.subportion.archive',
        type: ENTITIES_LABORATORY.SUBPORTION,
        url: 'portions/subportions/pendingArchive',
        gridExportWithBarcode: true
    },
    {
        id: 'operation.entity.subportion.cover',
        uicomponent: 'uicomponent.laboratory.subportion.cover',
        type: ENTITIES_LABORATORY.SUBPORTION,
        url: 'portions/subportions/pendingCover',
        actionUrl: 'portions/subportions/cover',
        deviceType: 'portions/subportions'
    },
    {
        id: 'operation.entity.subportion.stain-and-cover',
        uicomponent: 'uicomponent.laboratory.subportion.stain-and-cover',
        type: ENTITIES_LABORATORY.SUBPORTION,
        url: 'portions/subportions/pendingStainAndCover',
        actionUrl: 'portions/subportions/stainAndCover',
        deviceType: 'portions/subportions'
    },
    {
        id: 'operation.entity.subportion.stain',
        uicomponent: 'uicomponent.laboratory.subportion.stain',
        type: ENTITIES_LABORATORY.SUBPORTION,
        url: 'portions/subportions/pendingStain',
        actionUrl: 'portions/subportions/stain',
        deviceType: 'portions/subportions'
    },
    {
        id: 'operation.entity.subportion.to-covering',
        uicomponent: 'uicomponent.laboratory.subportion.to-covering',
        type: ENTITIES_LABORATORY.SUBPORTION,
        url: 'portions/subportions/pendingToCovering',
        actionUrl: 'portions/subportions/toCovering',
        deviceType: 'portions/subportions'
    },
    {
        id: 'operation.entity.subportion.to-pathologist',
        uicomponent: 'uicomponent.laboratory.subportion.to-pathologist',
        type: ENTITIES_LABORATORY.SUBPORTION,
        url: 'portions/subportions/pendingToPathologist',
        actionUrl: 'portions/subportions/toPathologist'
    },
    {
        id: 'operation.entity.subportion.to-scanner',
        uicomponent: 'uicomponent.laboratory.subportion.to-scanner',
        type: ENTITIES_LABORATORY.SUBPORTION,
        url: 'portions/subportions/pendingToScanner',
        actionUrl: 'portions/subportions/toScanner',
        deviceType: 'portions/subportions'
    },
    {
        id: 'operation.entity.subportion.to-stainer',
        uicomponent: 'uicomponent.laboratory.subportion.to-stainer',
        type: ENTITIES_LABORATORY.SUBPORTION,
        url: 'portions/subportions/pendingToStainer',
        actionUrl: 'portions/subportions/toStainer',
        deviceType: 'portions/subportions'
    },
    {
        id: 'operation.entity.subportion.unarchive-to-stain',
        uicomponent: 'uicomponent.laboratory.subportion.unarchive-to-stain',
        type: ENTITIES_LABORATORY.SUBPORTION,
        url: 'portions/subportions/pendingUnarchiveToStain',
        deviceType: 'portions/subportions',
        gridExportWithBarcode: true
    },
    {
        id: 'operation.entity.subportion.unarchive-to-scan',
        uicomponent: 'uicomponent.laboratory.subportion.unarchive-to-scan',
        type: ENTITIES_LABORATORY.SUBPORTION,
        url: 'portions/subportions/pendingUnarchiveToScan',
        deviceType: 'portions/subportions',
        gridExportWithBarcode: true
    },
    {
        id: 'operation.entity.subportion.slide.scan',
        uicomponent: 'uicomponent.laboratory.slide.scan',
        type: ENTITIES_LABORATORY.SUBPORTION,
        url: 'portions/subportions/pendingScan',
        actionUrl: 'portions/subportions/scan',
        deviceType: 'portions/subportions'
    },
    {
        id: 'operation.entity.subportion.scan',
        uicomponent: 'uicomponent.laboratory.subportion.scan',
        type: ENTITIES_LABORATORY.SUBPORTION,
        url: 'portions/subportions/pendingScan',
        actionUrl: 'portions/subportions/scan',
        deviceType: 'portions/subportions'
    },
    {
        id: SampleOperation.REPROCESS,
        uicomponent: 'uicomponent.laboratory.sample.reprocess',
        type: ENTITIES_LABORATORY.SAMPLE,
        url: 'pendingReprocess',
        actionUrl: 'process',
        isSingleElementOperation: true,
        isSampleProcessingOperation: true
    },
    {
        id: 'operation.entity.sample.unarchive',
        uicomponent: 'uicomponent.laboratory.sample.unarchive-to-reprocess',
        type: ENTITIES_LABORATORY.SAMPLE,
        url: 'pendingUnarchiveToReprocess',
        gridExportWithBarcode: true
    },
    {
        id: SampleOperation.PROCESS,
        uicomponent: 'uicomponent.laboratory.sample.process',
        type: ENTITIES_LABORATORY.SAMPLE,
        url: 'pendingProcess',
        actionUrl: 'process',
        isSingleElementOperation: true,
        isSampleProcessingOperation: true,
        additionalRequiredPermissions: [ SampleOperation.EDIT ]
    },
    {
        id: SampleOperation.TO_PROCESSOR,
        uicomponent: 'uicomponent.laboratory.sample.to-processor',
        type: ENTITIES_LABORATORY.SAMPLE,
        url: 'pendingToProcessor',
        actionUrl: 'toProcessor',
        additionalRequiredPermissions: [ SampleOperation.EDIT ]
    },
    {
        id: SampleOperation.FROM_PROCESSOR,
        uicomponent: 'uicomponent.laboratory.sample.from-processor',
        type: ENTITIES_LABORATORY.SAMPLE,
        url: 'pendingFromProcessor',
        actionUrl: 'fromProcessor',
        isSingleElementOperation: true,
        additionalRequiredPermissions: [ SampleOperation.EDIT ]
    },
    {
        id: SampleOperation.ARCHIVE,
        uicomponent: 'uicomponent.laboratory.sample.archive',
        type: ENTITIES_LABORATORY.SAMPLE,
        url: 'pendingArchive',
        gridExportWithBarcode: true
    }
]
